import { UsuarioSistemaPerfilResponse } from "./usuarioSistemaPerfilResponse"

export const USUARIO_SISTEMA_PERFIL_GET = 'USUARIO_SISTEMA_PERFIL_GET'

export interface UsuarioSistemaPerfilState {
    usuarioSistemaPerfil: UsuarioSistemaPerfilResponse[] | undefined
}

export interface UsuarioSistemaPerfilAction {
    type: typeof USUARIO_SISTEMA_PERFIL_GET,
    payload: UsuarioSistemaPerfilResponse[]
}

export type UsuarioSistemaPerfilActionTypes = UsuarioSistemaPerfilAction
